<div class="layout-root base-bg">
  <app-header class="fixed top-0 right-0 left-0"></app-header>
  <app-update-banner></app-update-banner>
  <main class="layout-main">
    <!-- <p class="fixed bottom-0 right-0 z-10 text-xs text-gray-500 p-1 font-sans">v1.0.0-{{enviromentName}}</p> -->
    <router-outlet></router-outlet>
  </main>
  @if (showGlobalFooter) {
    <app-footer class="layout-footer"></app-footer>
  }
</div>
